// modules/DownloadButton.js
import React         from 'react';
import Arrow         from '../images/arrow';
import renderHTML    from 'react-render-html';

class DownloadButton extends React.Component {
	render() {
		if (this.props.link) {
			var d = new Date();
			var link = this.props.link + "?ts=" + d.getTime();
			return (
				<a href={link} target="_blank">
					<div className={this.props.bclass}>
						<div className="pdfdownload_rbg"><Arrow/></div>
						<div className="site-downloads-button-text">
							<div>{renderHTML(this.props.children)}</div>
						</div>
					</div>
				</a>
			);
		} else {
			return null;
		}
	}
}

export default DownloadButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/DownloadButton.js
 **/